module.exports = __webpack_public_path__ + "img/4.a80eff08.png";